__turbopack_context__.v({
  "actions": "_1YJOmq_actions",
  "consent": "_1YJOmq_consent",
  "consentBox": "_1YJOmq_consentBox",
  "field": "_1YJOmq_field",
  "fieldRow": "_1YJOmq_fieldRow",
  "form": "_1YJOmq_form",
  "formMessage": "_1YJOmq_formMessage",
  "fullWidthCTA": "_1YJOmq_fullWidthCTA",
  "hiddenLabel": "_1YJOmq_hiddenLabel",
  "honeypot": "_1YJOmq_honeypot",
  "input": "_1YJOmq_input",
  "introColumn": "_1YJOmq_introColumn",
  "introHeading": "_1YJOmq_introHeading",
  "shell": "_1YJOmq_shell",
});
